import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M6384 9376 c11 -9 24 -16 30 -16 12 0 7 5 -24 19 -24 11 -24 11 -6
-3z"/>
<path d="M6420 9341 c0 -10 24 -21 43 -21 7 0 3 7 -7 15 -22 17 -36 19 -36 6z"/>
<path d="M6486 9305 c5 -13 2 -14 -21 -5 -34 13 -55 13 -55 0 0 -5 12 -11 28
-11 20 -1 22 -3 7 -6 -11 -3 -25 -13 -32 -22 -11 -14 -13 -14 -14 4 -1 11 -1
26 0 34 2 7 -2 10 -8 6 -6 -3 -11 -13 -11 -21 0 -8 -7 -14 -16 -14 -9 0 -26
-8 -39 -19 -18 -13 -21 -21 -12 -30 20 -20 0 -12 -63 25 -98 57 -79 33 24 -31
99 -61 146 -97 237 -182 31 -29 59 -53 63 -53 4 0 28 20 54 44 26 25 60 56 76
70 l30 25 -49 43 c-27 24 -65 56 -84 71 -20 16 -38 32 -41 35 -7 10 -68 52
-74 52 -3 0 -3 -7 0 -15z m-106 -125 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3
6 -1 10 4 10 6 0 11 -4 11 -10z"/>
<path d="M4275 9290 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M6285 9270 c18 -8 18 -9 2 -9 -10 -1 -15 -5 -12 -11 8 -12 16 -12 35
0 13 9 13 11 0 20 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z"/>
<path d="M4169 9208 c-35 -29 -77 -65 -94 -81 l-30 -28 40 -36 c22 -19 59 -51
81 -69 l41 -34 79 75 c43 41 81 75 85 75 3 0 19 12 35 26 16 14 41 32 57 40
15 8 27 17 27 20 0 3 -16 -3 -36 -15 -23 -14 -52 -21 -85 -21 -42 0 -49 3 -49
20 0 17 -7 20 -46 20 -27 0 -43 4 -39 10 3 6 2 10 -4 10 -5 0 -13 -4 -16 -10
-3 -5 -12 -10 -18 -10 -7 0 2 11 18 24 17 13 27 27 24 30 -4 4 -35 -17 -70
-46z"/>
<path d="M5848 9173 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6020 9096 c0 -8 6 -17 13 -20 6 -3 2 -3 -10 0 -13 3 -23 1 -23 -5 0
-6 -18 -11 -40 -11 -27 0 -40 -4 -40 -14 0 -15 -46 -11 -56 5 -9 15 -47 10
-82 -11 -34 -21 -58 -27 -32 -9 12 9 12 10 -3 5 -10 -3 -31 -6 -45 -7 -16 0 7
-11 58 -28 165 -53 338 -153 455 -263 22 -21 43 -38 47 -38 9 0 152 127 156
138 4 13 -157 144 -233 189 -42 25 -118 65 -141 73 -18 7 -24 6 -24 -4z m-180
-65 c0 -9 -24 -21 -41 -21 -16 0 -10 18 9 23 28 8 32 7 32 -2z"/>
<path d="M4690 9069 c-36 -17 -66 -35 -68 -40 -2 -5 -9 -9 -15 -9 -14 0 -195
-137 -224 -170 l-22 -25 77 -72 c75 -71 92 -82 92 -64 0 5 37 40 83 78 121
102 271 188 395 229 63 20 64 27 2 12 -25 -6 -52 -10 -60 -10 -8 -1 -22 -7
-31 -15 -14 -12 -17 -11 -22 8 -3 11 -10 18 -15 15 -6 -3 -13 0 -16 6 -5 10
-7 10 -12 1 -8 -19 -54 -16 -54 2 0 11 -11 15 -36 15 -40 0 -77 16 -69 31 4 5
11 9 16 9 6 0 7 -4 4 -10 -3 -6 4 -10 17 -10 22 1 22 1 4 12 -18 10 -17 12 10
24 16 7 25 13 19 13 -5 1 -39 -13 -75 -30z"/>
<path d="M5128 9033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5078 9023 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3754 8962 c-386 -242 -652 -524 -862 -912 -69 -128 -158 -343 -206
-500 -76 -246 -109 -470 -109 -745 0 -201 9 -298 49 -511 13 -72 24 -135 24
-140 0 -14 -53 -68 -81 -82 -41 -21 -219 -200 -277 -277 -162 -218 -197 -410
-97 -540 58 -77 202 -144 375 -176 97 -18 499 -18 630 -1 299 41 521 87 820
170 201 56 318 97 300 105 -8 4 -1 5 15 2 20 -4 26 -3 16 4 -11 7 -5 15 27 35
23 14 50 26 59 27 10 0 13 3 6 5 -17 7 16 44 39 44 16 0 23 11 19 34 -3 17 20
34 42 30 l22 -5 -22 10 c-32 14 -29 25 13 40 19 7 33 15 30 18 -2 3 -44 -9
-93 -25 -251 -87 -757 -222 -977 -262 -459 -82 -830 -84 -1029 -5 -82 33 -160
101 -182 160 -36 94 -4 216 98 369 58 86 233 276 255 276 6 0 23 -39 38 -87
64 -206 174 -439 296 -624 l51 -77 61 5 c118 9 386 51 386 61 0 2 -24 35 -53
71 -217 271 -355 544 -451 889 -97 349 -120 695 -71 1062 4 27 3 30 -4 15
l-10 -20 -1 20 c-2 17 -3 17 -11 -5 -8 -23 -8 -22 -4 6 2 17 -2 42 -9 55 -6
13 -10 44 -8 68 3 28 0 46 -8 51 -7 4 -14 24 -15 44 -3 30 0 36 16 36 12 0 19
7 19 20 0 17 7 20 38 20 30 0 42 5 51 23 11 20 11 20 6 -8 -11 -55 -17 -110
-12 -105 3 3 7 19 10 35 5 30 39 132 56 170 5 11 17 44 26 74 50 163 238 498
386 687 88 112 261 291 352 362 31 25 57 49 57 53 0 12 8 16 -96 -49z m-954
-1259 c0 -19 -20 -26 -20 -6 -1 17 -2 17 -15 -1 -16 -21 -19 -18 -9 7 7 18 44
18 44 0z"/>
<path d="M6885 8918 c112 -105 233 -243 330 -379 47 -64 85 -121 85 -125 0 -4
6 -15 14 -23 59 -66 206 -385 261 -566 15 -49 32 -94 37 -100 7 -7 8 -3 4 10
-5 16 -1 20 19 21 22 2 24 -1 20 -30 l-5 -31 10 32 c6 18 19 37 29 42 29 16
72 -1 86 -34 10 -23 13 -25 14 -10 0 11 -6 29 -14 39 -8 11 -15 27 -14 35 0 9
5 4 11 -11 5 -16 13 -28 17 -28 4 0 15 -24 25 -54 23 -68 16 -113 -25 -151
-26 -26 -30 -36 -28 -77 2 -36 7 -48 18 -49 9 0 -13 -10 -49 -23 -84 -30 -138
-54 -122 -55 6 -1 72 12 145 28 206 46 320 62 487 68 278 10 424 -33 501 -147
32 -48 32 -150 0 -233 -73 -185 -265 -391 -631 -675 -42 -33 -297 -210 -345
-239 -11 -7 -85 -54 -165 -104 -157 -100 -336 -205 -470 -277 -47 -25 -132
-71 -190 -102 -338 -185 -1036 -520 -1407 -676 -171 -71 -119 -55 342 106 109
38 162 59 420 162 110 44 220 88 245 98 108 42 439 190 596 267 45 21 83 48
99 69 14 19 32 34 39 34 7 0 30 14 51 30 21 17 43 30 49 30 6 0 36 15 67 34
31 19 67 37 79 41 12 4 49 22 81 41 31 19 65 34 75 34 9 0 44 17 78 38 34 21
77 44 96 51 19 6 51 23 71 36 19 14 58 33 86 43 28 10 76 38 108 62 31 24 64
44 73 45 31 2 87 35 161 95 41 33 77 57 80 54 8 -8 -164 -169 -258 -242 -40
-31 -90 -70 -111 -87 -21 -16 -51 -39 -66 -50 -16 -11 -45 -35 -64 -53 -56
-54 -145 -131 -187 -161 -21 -15 -46 -38 -57 -49 -18 -21 -18 -21 10 -13 16 5
49 18 74 30 24 11 50 21 57 21 7 0 13 5 13 10 0 6 5 10 11 10 5 0 35 12 65 26
69 33 103 25 50 -11 -20 -14 -42 -25 -48 -25 -6 0 -8 -3 -5 -7 11 -11 -41 -41
-283 -165 -172 -89 -296 -138 -345 -138 -39 0 -40 19 -2 21 20 1 20 2 3 6 -26
7 -117 -13 -191 -42 -33 -13 -83 -31 -112 -39 -28 -8 -103 -37 -166 -65 -63
-28 -118 -51 -122 -51 -4 0 -21 -7 -38 -15 -73 -33 -626 -262 -867 -357 -41
-17 -77 -32 -80 -35 -10 -10 80 11 345 78 355 90 592 161 864 259 63 22 116
39 118 37 13 -13 -254 -215 -402 -304 -200 -121 -415 -211 -651 -273 -304 -81
-578 -102 -940 -74 l-81 7 -159 -147 c-87 -81 -160 -151 -162 -156 -4 -12 48
-25 190 -50 327 -55 737 -54 1028 4 170 34 385 95 439 126 15 8 14 9 -1 15
-10 4 -40 -4 -70 -18 -29 -13 -69 -25 -88 -26 -19 -1 -39 -6 -44 -11 -20 -20
-116 -10 -116 12 0 6 7 7 16 4 8 -3 12 -2 9 4 -3 6 1 10 9 10 36 0 362 116
492 176 255 116 518 282 734 463 83 69 118 84 128 52 3 -8 0 -11 -7 -7 -10 6
-15 -5 -13 -26 1 -3 -6 -12 -16 -20 -15 -12 -16 -11 -3 5 7 9 9 17 3 17 -14 0
-22 -24 -13 -39 8 -13 202 172 275 262 21 26 43 47 48 47 19 0 332 128 452
185 89 42 116 59 105 66 -9 7 -5 7 15 3 22 -5 27 -4 21 6 -5 8 -4 11 2 7 13
-8 93 23 93 37 0 6 -5 5 -12 -2 -7 -7 -21 -12 -32 -11 -15 0 -17 2 -6 6 8 4
29 16 45 28 17 13 55 33 85 46 30 12 64 29 75 37 l20 14 -20 -7 c-11 -4 -42
-14 -69 -22 -43 -13 -136 -50 -306 -123 -111 -47 -338 -142 -370 -155 -95 -37
-471 -175 -478 -175 -12 1 49 32 128 65 294 123 962 468 1166 603 7 4 47 30
90 59 44 28 90 61 104 72 22 18 23 20 6 21 -20 0 -20 0 0 15 17 13 14 13 -26
1 -25 -7 -89 -32 -143 -55 -54 -24 -100 -41 -103 -39 -2 2 14 15 36 29 74 44
79 49 43 43 -20 -4 -33 -2 -33 4 0 5 34 36 76 68 138 107 213 175 208 188 -3
7 18 33 46 59 27 25 50 49 50 53 0 4 -8 0 -17 -8 -36 -30 -47 -30 -19 0 17 18
27 32 24 32 -3 0 -58 -32 -122 -70 -64 -39 -118 -70 -122 -70 -3 0 -26 -14
-50 -31 -25 -17 -47 -29 -50 -26 -2 2 31 35 73 73 132 117 277 282 338 386 44
75 94 188 101 230 4 30 3 28 -15 -12 -57 -135 -169 -275 -296 -371 -94 -71
-119 -81 -68 -26 38 41 78 96 87 121 6 18 5 18 -16 2 -72 -51 -72 -51 9 68
135 198 190 392 152 530 -14 50 -106 143 -170 173 -160 75 -435 83 -738 22
-100 -19 -121 -16 -121 22 0 21 -30 122 -67 224 -14 39 -32 88 -40 110 -72
204 -263 546 -371 665 -13 14 -31 37 -40 52 -29 49 -244 252 -334 316 -86 60
-215 142 -225 142 -3 0 29 -33 72 -72z m1775 -2913 c0 -6 -56 -35 -67 -35 -14
1 39 40 53 40 8 0 14 -2 14 -5z"/>
<path d="M5235 8841 c-159 -26 -334 -101 -462 -199 -116 -88 -114 -78 -29
-160 41 -40 78 -72 83 -72 5 0 20 12 34 26 57 61 183 137 286 172 245 84 530
32 736 -134 37 -30 72 -51 79 -48 7 3 44 35 82 73 l68 68 -83 66 c-79 63 -228
147 -261 147 -8 0 -18 4 -24 9 -5 5 -43 19 -84 31 -83 24 -332 36 -425 21z
m118 -8 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z"/>
<path d="M5322 8448 c-100 -22 -176 -148 -152 -253 13 -58 35 -101 57 -114 21
-11 22 -10 -107 -441 -48 -162 -109 -367 -135 -455 -26 -88 -67 -227 -92 -310
-25 -82 -60 -202 -78 -265 -18 -63 -49 -169 -68 -235 -206 -702 -198 -675
-183 -675 17 0 319 110 330 120 4 4 -1 11 -13 15 -12 3 -21 10 -21 15 0 9 118
90 131 90 4 0 19 21 35 48 15 26 44 69 66 96 45 57 49 75 11 48 -60 -41 -284
-174 -288 -170 -5 4 111 453 120 468 5 8 43 -11 135 -70 76 -49 149 -90 159
-90 12 0 65 70 58 77 -7 6 -75 49 -197 123 -49 30 -90 57 -90 61 0 3 46 46
102 95 56 49 125 110 153 135 27 26 54 48 58 50 5 2 8 -95 7 -216 -1 -252 -13
-239 99 -107 l62 74 -7 164 c-4 90 -4 164 -1 164 3 0 52 -23 109 -51 l103 -50
83 86 c45 47 82 89 82 93 0 12 -55 201 -181 627 -145 492 -140 467 -106 503
71 74 61 229 -19 304 -58 54 -125 68 -222 46z m8 -933 c-1 -250 -4 -455 -8
-455 -9 0 -150 152 -152 163 -1 5 30 42 69 83 72 75 81 89 59 97 -10 3 -10 9
0 27 23 39 6 33 -58 -20 -34 -29 -63 -50 -65 -48 -2 2 30 137 71 301 41 164
74 300 74 302 0 3 2 5 5 5 3 0 5 -205 5 -455z m195 171 c36 -147 65 -274 63
-281 -2 -9 -28 9 -67 44 l-64 58 -5 229 c-2 126 -2 227 1 224 3 -3 35 -126 72
-274z m65 -415 c0 -3 -29 -37 -65 -76 l-64 -70 -1 133 0 134 65 -57 c36 -32
65 -60 65 -64z m71 -162 c33 -127 51 -211 46 -215 -5 -6 -215 94 -222 106 -6
10 137 180 150 176 6 -1 17 -31 26 -67z m-484 -26 c27 -27 70 -67 96 -90 26
-22 47 -47 47 -55 -1 -7 -45 -48 -98 -90 -53 -43 -123 -101 -155 -129 -32 -29
-60 -49 -64 -45 -7 6 0 33 61 266 20 74 39 147 42 163 4 15 10 27 14 27 4 0
30 -21 57 -47z"/>
<path d="M4410 7798 c0 -33 -3 -40 -11 -28 -8 12 -12 12 -16 2 -4 -10 -13 -6
-34 14 l-29 28 0 -47 0 -47 59 0 c65 0 66 1 70 73 2 42 0 47 -18 47 -18 0 -21
-6 -21 -42z"/>
<path d="M7621 7684 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7790 7690 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3977 7543 c-4 -46 -5 -94 -1 -108 6 -25 8 -25 105 -25 l99 0 0 105
0 105 -52 -2 -53 -2 48 -3 c46 -4 47 -5 46 -36 -2 -30 -2 -31 -6 -4 -4 24 -8
27 -44 27 -28 0 -39 -4 -39 -15 0 -11 -11 -15 -40 -15 -31 0 -40 -4 -42 -17 0
-10 -4 2 -7 27 -6 42 -7 39 -14 -37z"/>
<path d="M2927 7538 c-3 -18 -8 -43 -12 -55 -4 -14 -3 -23 3 -23 10 0 28 97
19 106 -2 3 -7 -10 -10 -28z"/>
<path d="M3363 7443 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M7670 7420 c0 -23 15 -25 50 -5 25 14 25 14 -9 8 -25 -4 -32 -3 -27
5 4 7 2 12 -3 12 -6 0 -11 -9 -11 -20z"/>
<path d="M3350 7385 c0 -23 4 -25 41 -25 33 0 40 3 37 18 -2 9 -9 16 -16 15
-6 -2 -23 2 -37 7 -23 9 -25 7 -25 -15z"/>
<path d="M3670 7230 l0 -110 111 0 112 0 -7 61 c-3 34 -6 84 -6 110 l0 49
-105 0 -105 0 0 -110z m153 93 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35
-2 23 -4z"/>
<path d="M7910 7280 c-69 -11 -152 -26 -185 -34 -33 -8 -76 -18 -95 -21 -111
-22 -559 -161 -600 -186 -18 -12 -20 -12 155 35 132 36 191 49 395 91 264 53
458 58 547 14 117 -58 121 -165 12 -326 -16 -25 -28 -47 -26 -50 2 -2 12 8 21
22 20 30 42 35 26 5 -7 -14 -7 -20 0 -20 5 0 10 -5 10 -11 0 -5 -4 -7 -10 -4
-5 3 -10 0 -10 -7 0 -27 -20 -37 -48 -22 -18 9 -30 10 -39 3 -13 -12 -13 -50
0 -60 9 -6 -56 -74 -119 -124 -20 -17 -52 -43 -70 -59 -19 -15 -34 -23 -34
-16 0 6 -5 8 -10 5 -8 -5 -7 -11 1 -21 10 -12 9 -13 -4 -8 -9 3 -26 -6 -44
-23 -27 -28 -107 -73 -130 -73 -7 0 -19 -7 -28 -17 -14 -14 -18 -14 -26 -2 -7
10 -8 8 -7 -10 2 -13 -4 -26 -12 -31 -8 -4 -25 -12 -37 -19 -13 -6 -23 -7 -23
-2 0 5 6 12 13 14 9 4 9 6 -1 6 -7 1 -15 -6 -18 -14 -4 -8 -12 -15 -18 -15
-14 0 -109 -60 -114 -72 -2 -5 -8 -8 -14 -8 -5 0 -82 -44 -171 -98 -166 -101
-260 -155 -452 -259 -99 -54 -166 -90 -375 -201 -36 -19 -166 -86 -290 -149
-124 -64 -240 -128 -258 -144 -18 -16 -30 -29 -28 -29 10 0 121 43 131 51 6 4
48 23 95 42 341 141 916 418 1207 583 62 35 117 64 123 64 5 0 10 3 10 8 0 4
17 16 38 27 48 25 162 105 162 114 0 9 102 74 117 74 7 0 11 2 8 5 -11 11 105
82 133 82 22 0 49 16 97 55 37 30 73 55 79 56 6 0 34 18 61 40 28 21 84 65
125 96 95 72 244 222 291 293 43 65 69 136 69 189 0 66 -63 135 -149 162 -66
21 -342 20 -481 -1z"/>
<path d="M7715 7129 c-27 -4 -70 -12 -95 -17 l-45 -8 32 -8 c19 -4 42 -20 54
-38 21 -29 21 -34 10 -146 -6 -65 -19 -152 -28 -195 -15 -73 -19 -81 -68 -126
-57 -51 -354 -254 -500 -341 -49 -29 -106 -63 -125 -75 -19 -13 -68 -41 -107
-64 -40 -22 -103 -58 -140 -80 -38 -21 -108 -59 -158 -84 -90 -46 -175 -96
-164 -97 24 -1 630 302 789 395 247 143 543 330 581 367 8 7 34 29 59 48 25
18 73 58 108 88 l62 54 0 92 c0 51 -3 127 -6 169 l-7 77 -101 -1 c-56 -1 -123
-5 -151 -10z"/>
<path d="M3320 7005 l0 -65 66 0 65 0 -3 53 -3 52 -45 6 -45 5 45 5 c42 5 40
6 -17 7 l-63 2 0 -65z"/>
<path d="M3968 6955 c-2 -55 -2 -103 0 -107 2 -5 50 -8 108 -8 l104 0 0 105 0
105 -67 2 c-38 1 -84 2 -105 3 l-36 1 -4 -101z"/>
<path d="M6426 6995 c-3 -9 -11 -13 -17 -10 -6 4 -10 1 -8 -6 3 -27 -1 -36
-26 -47 -21 -10 -26 -9 -35 9 -10 17 -13 18 -25 5 -8 -8 -29 -18 -47 -22 -22
-4 -52 -27 -93 -71 -33 -36 -86 -93 -117 -127 -32 -33 -58 -67 -58 -73 0 -7
-6 -13 -12 -13 -7 -1 -26 -19 -43 -40 -16 -21 -37 -39 -45 -40 -8 0 -21 -9
-28 -20 -16 -25 -49 -25 -87 0 -16 11 -38 20 -47 20 -10 0 -18 5 -18 10 0 6
-4 10 -10 10 -5 0 -7 -6 -4 -14 3 -8 -3 -16 -17 -19 -19 -5 -21 -3 -15 23 l5
29 -22 -22 c-12 -12 -89 -98 -171 -192 -195 -223 -196 -225 -230 -270 -24 -31
-26 -37 -10 -31 10 4 60 18 109 31 50 14 196 54 325 89 129 36 236 63 239 61
3 -4 -43 -68 -76 -105 -8 -8 -37 -46 -65 -85 -29 -38 -56 -74 -60 -80 -21 -25
-193 -268 -311 -440 -72 -104 -135 -194 -139 -200 -5 -5 -41 -57 -80 -115 -92
-136 -178 -261 -261 -380 -81 -116 -280 -409 -292 -430 -14 -24 18 2 115 96
47 44 141 135 210 200 512 488 921 893 1140 1129 254 275 497 554 575 660 16
22 32 42 35 45 3 3 13 16 22 30 10 14 33 47 52 75 40 56 34 81 -16 71 -28 -6
-39 7 -15 18 20 10 -54 0 -108 -14 -27 -7 -131 -34 -230 -60 -99 -26 -184 -44
-188 -40 -4 4 29 66 75 139 119 189 139 223 135 228 -3 2 -7 -3 -11 -12z"/>
<path d="M9380 6989 c-18 -16 -25 -31 -25 -60 0 -23 6 -44 14 -48 14 -9 0 -26
-131 -166 -26 -27 -45 -52 -42 -54 3 -3 47 39 99 93 l94 98 -6 49 c-7 58 13
89 57 89 46 0 77 -58 52 -97 -11 -17 -59 -33 -79 -26 -11 4 -14 3 -9 -5 10
-17 53 -15 87 5 25 15 29 24 29 59 0 34 -5 47 -26 63 -34 27 -82 26 -114 0z"/>
<path d="M6350 6949 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3587 6773 c-2 -4 -5 -54 -6 -110 l-2 -103 111 0 111 0 -3 108 -3
107 -102 3 c-56 1 -103 -1 -106 -5z"/>
<path d="M3160 6715 c0 -21 5 -25 30 -25 25 0 30 4 30 25 0 21 -5 25 -30 25
-25 0 -30 -4 -30 -25z"/>
<path d="M8805 6710 c-10 -11 -14 -20 -9 -20 5 0 15 9 22 20 7 11 11 20 9 20
-2 0 -12 -9 -22 -20z"/>
<path d="M4327 6703 c-4 -3 -7 -15 -7 -25 0 -13 8 -18 30 -18 25 0 30 4 30 25
0 20 -5 25 -23 25 -13 0 -27 -3 -30 -7z"/>
<path d="M7964 6668 l-29 -33 33 29 c30 28 37 36 29 36 -2 0 -16 -15 -33 -32z"/>
<path d="M7982 6654 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M9373 6608 c-43 -11 -67 -48 -60 -92 3 -22 0 -42 -9 -55 -16 -22 -6
-29 13 -10 7 7 23 8 45 3 48 -11 70 -6 96 22 27 31 28 73 2 106 -24 31 -45 37
-87 26z m61 -29 c30 -24 35 -69 10 -93 -22 -23 -62 -30 -79 -16 -8 7 -15 9
-15 4 0 -5 -5 -2 -10 6 -17 26 -11 73 12 97 27 28 48 29 82 2z"/>
<path d="M9081 6571 c-8 -5 -15 -19 -16 -30 -2 -19 0 -20 15 -6 9 8 17 22 17
30 0 8 -1 15 -1 15 -1 0 -7 -4 -15 -9z"/>
<path d="M7777 6514 c-21 -14 -35 -29 -33 -33 3 -4 -6 -13 -21 -20 -32 -15
-27 -21 10 -14 22 4 27 10 24 24 -4 14 1 21 19 25 23 6 51 31 42 39 -2 2 -21
-7 -41 -21z"/>
<path d="M3280 6435 l0 -66 58 3 57 3 3 63 3 62 -61 0 -60 0 0 -65z"/>
<path d="M4207 6414 c-4 -4 -7 -38 -7 -76 l0 -68 75 0 76 0 -3 73 -3 72 -65 3
c-36 2 -69 0 -73 -4z"/>
<path d="M7641 6411 c-10 -7 -7 -9 12 -8 14 1 23 5 20 10 -6 9 -15 9 -32 -2z"/>
<path d="M9230 6400 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M9154 6351 c-23 -14 -48 -33 -57 -41 -8 -8 -38 -28 -67 -45 -80 -47
-150 -101 -142 -110 4 -5 1 -5 -6 -1 -8 5 -29 -3 -53 -18 -47 -32 -51 -43 -6
-20 29 16 31 16 18 1 -7 -10 -11 -17 -8 -17 21 0 257 168 303 216 11 12 30 25
42 28 11 4 23 13 26 21 8 21 -2 18 -50 -14z"/>
<path d="M7550 6339 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3540 6240 l0 -50 50 0 50 0 0 50 0 50 -50 0 -50 0 0 -50z"/>
<path d="M3835 6197 c-3 -12 -5 -50 -3 -82 l3 -60 60 -3 c32 -2 70 0 83 3 23
6 23 9 20 83 l-3 77 -77 3 c-74 3 -78 2 -83 -21z"/>
<path d="M9198 6174 c-37 -16 -48 -35 -48 -86 0 -27 -1 -28 -145 -108 -22 -13
-110 -59 -195 -103 -159 -82 -184 -97 -160 -97 9 0 8 -5 -6 -16 -10 -8 32 10
94 42 61 31 112 60 112 65 0 5 6 9 13 9 6 0 25 7 41 15 105 55 135 72 167 97
20 15 43 28 51 28 8 0 19 5 25 11 9 9 18 8 37 -5 34 -22 68 -20 100 5 40 32
49 54 36 94 -7 22 -22 38 -44 49 -40 19 -32 19 -78 0z m81 -30 c40 -51 18
-108 -42 -108 -46 0 -67 19 -67 60 0 68 70 98 109 48z"/>
<path d="M2405 6089 c-255 -201 -429 -383 -535 -559 -93 -156 -125 -287 -96
-400 36 -140 122 -233 301 -323 301 -151 843 -179 1455 -76 416 70 834 181
1305 346 132 46 150 58 180 120 9 18 20 35 25 38 18 11 10 23 -10 18 -11 -3
-25 -14 -30 -24 -6 -10 -18 -18 -28 -18 -9 -1 -34 -4 -54 -7 -31 -5 -38 -10
-38 -29 0 -19 -6 -23 -41 -27 -22 -2 -43 0 -45 4 -2 4 -21 1 -42 -6 -62 -22
-150 -29 -184 -15 -24 10 -31 10 -37 0 -6 -10 -18 -10 -48 -2 -30 8 -55 7
-104 -3 -211 -46 -288 -64 -297 -70 -6 -3 -13 -2 -17 4 -3 5 -1 10 6 10 7 0
10 2 8 4 -2 2 -24 0 -49 -5 -25 -5 -79 -15 -120 -23 -41 -8 -129 -26 -195 -40
-66 -14 -201 -37 -300 -53 -165 -25 -205 -27 -480 -28 -317 0 -373 5 -531 51
-129 37 -211 81 -281 149 -66 66 -89 110 -104 195 -31 190 119 464 421 769 52
53 67 71 58 71 -2 0 -43 -32 -93 -71z"/>
<path d="M8605 6080 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M3300 6035 l0 -45 45 0 45 0 0 45 0 45 -45 0 -45 0 0 -45z"/>
<path d="M5480 5946 c-14 -8 -79 -35 -145 -60 -66 -26 -134 -53 -150 -61 -17
-8 -44 -19 -60 -26 -17 -6 -24 -13 -17 -16 6 -3 10 -8 8 -12 -3 -4 5 -7 17 -7
12 1 21 -4 20 -11 -2 -6 9 -21 22 -31 14 -11 25 -25 25 -31 0 -6 6 -11 13 -12
6 0 1 -5 -12 -10 -13 -5 -22 -12 -19 -14 4 -5 38 7 103 34 11 5 35 15 53 22
20 7 44 28 58 51 23 36 77 110 109 150 7 9 11 19 8 22 -4 3 -1 6 5 6 7 0 12 5
12 10 0 14 -20 12 -50 -4z m-295 -148 c-19 -11 -19 -11 0 -19 16 -6 17 -8 3
-8 -23 -1 -34 19 -17 30 8 5 19 9 24 9 6 -1 1 -6 -10 -12z m141 -69 c3 -5 1
-9 -5 -9 -5 0 -16 -2 -23 -5 -9 -4 -14 2 -14 13 0 13 6 18 18 14 10 -2 21 -8
24 -13z"/>
<path d="M3580 5835 l0 -75 65 0 65 0 0 69 c0 78 -3 81 -81 81 l-49 0 0 -75z"/>
<path d="M5050 5771 c-14 -5 -34 -13 -45 -19 -11 -6 -55 -23 -98 -39 -43 -15
-73 -29 -68 -31 9 -3 108 32 176 62 17 7 41 18 55 24 29 12 17 14 -20 3z"/>
<path d="M8550 5750 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M5025 5720 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4946 5701 c-4 -6 -1 -11 6 -11 9 0 9 -3 -2 -10 -9 -6 -10 -10 -3
-10 17 0 23 14 14 29 -6 9 -11 10 -15 2z"/>
<path d="M4908 5683 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4710 5640 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M4630 5614 c-22 -9 -26 -12 -10 -9 14 2 35 5 48 5 12 0 22 5 22 10 0
13 -18 12 -60 -6z"/>
<path d="M5108 5372 c9 -7 8 -13 -8 -27 -20 -18 -26 -35 -12 -35 8 0 42 52 42
64 0 3 -8 6 -17 6 -13 0 -15 -2 -5 -8z"/>
<path d="M5060 5285 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M7226 4915 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z"/>
<path d="M4710 4840 c-36 -11 -118 -27 -183 -36 -97 -13 -127 -14 -162 -4 -39
11 -55 9 -142 -14 -489 -128 -892 -193 -1278 -204 -167 -5 -203 -8 -150 -13
206 -19 572 -5 815 33 231 35 233 35 287 0 58 -37 223 -120 313 -157 73 -30
262 -96 266 -92 1 1 32 49 69 107 38 58 84 129 103 158 19 29 31 57 26 61 -5
4 -28 13 -51 20 -24 6 -43 15 -43 20 0 4 36 19 81 32 73 22 84 28 111 67 33
48 30 49 -62 22z"/>
<path d="M6495 4473 c-18 -14 -18 -15 -2 -9 10 3 23 6 28 6 5 0 9 5 9 10 0 14
-12 12 -35 -7z"/>
<path d="M6350 4415 c-16 -19 0 -19 36 0 l29 15 -26 0 c-15 0 -32 -7 -39 -15z"/>
<path d="M1642 3883 l-123 -4 -25 -42 c-24 -41 -239 -423 -294 -522 -15 -27
-69 -124 -120 -215 -51 -91 -113 -202 -137 -248 l-45 -82 172 2 172 3 22 40
c11 22 37 69 57 105 20 36 50 90 67 120 16 30 72 129 123 220 51 91 108 193
126 228 19 34 38 62 42 62 4 0 28 -37 53 -82 98 -176 178 -328 178 -338 0 -6
-55 -10 -147 -10 l-148 0 -21 -38 c-11 -20 -40 -69 -62 -109 -23 -40 -42 -75
-42 -78 0 -3 126 -5 280 -5 l280 0 30 -60 30 -60 170 0 c94 0 170 3 170 6 0 3
-57 110 -127 238 -181 329 -194 354 -348 629 l-138 247 -36 -2 c-20 -1 -91 -4
-159 -5z"/>
<path d="M2524 3881 c-2 -2 -4 -253 -4 -558 l0 -553 443 0 442 0 75 115 c41
64 74 118 72 122 -1 3 -163 6 -360 7 l-357 1 -5 433 -5 433 -148 2 c-82 1
-151 0 -153 -2z"/>
<path d="M4860 3870 c-8 -5 -27 -10 -42 -10 -22 0 -32 -9 -54 -50 -15 -27 -31
-50 -36 -50 -4 0 -8 -5 -8 -11 0 -6 -39 -75 -87 -153 -47 -77 -98 -161 -112
-186 -14 -25 -29 -46 -33 -48 -4 -2 -8 -8 -8 -12 0 -5 -35 -67 -78 -137 -43
-70 -118 -191 -165 -269 -48 -77 -89 -148 -93 -157 -6 -15 8 -17 149 -17 l156
0 51 88 c29 48 67 112 85 142 18 30 68 116 111 190 42 74 102 178 132 230 30
52 68 121 85 153 45 86 49 87 87 15 18 -35 38 -70 45 -78 7 -8 27 -44 46 -80
19 -36 38 -70 44 -77 5 -6 37 -60 70 -118 33 -58 107 -186 165 -283 l105 -177
159 -3 c87 -1 156 1 154 6 -3 10 -145 245 -190 315 -15 23 -40 65 -56 92 -56
97 -344 570 -356 585 -7 8 -21 32 -31 53 -19 36 -38 50 -32 25 1 -9 -13 -14
-40 -16 -24 -2 -43 -7 -43 -13 0 -5 -18 -9 -40 -9 -22 0 -40 4 -40 9 0 4 -33
12 -72 17 -50 5 -63 9 -40 12 19 2 32 9 32 18 0 17 0 17 -20 4z m-63 -52 c-3
-8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m359 -28 c8 -7 14 -17 14
-22 0 -6 -7 -5 -15 2 -13 10 -15 9 -15 -9 0 -12 -4 -19 -10 -16 -7 4 -7 12 0
25 12 23 13 33 1 26 -4 -3 -6 7 -2 22 5 24 6 25 9 5 2 -12 10 -27 18 -33z"/>
<path d="M5970 3790 c-46 -38 -34 -39 15 0 21 17 34 30 28 30 -5 0 -24 -13
-43 -30z"/>
<path d="M7706 3783 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M6028 3763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8827 3763 c-4 -3 -7 -13 -7 -22 1 -13 3 -13 11 2 11 19 8 33 -4 20z"/>
<path d="M6955 3710 c-20 -27 -44 -50 -53 -50 -10 0 -169 0 -355 0 -325 0
-387 6 -387 32 0 4 -12 8 -26 8 -14 0 -23 -4 -19 -10 3 -5 0 -10 -9 -10 -8 0
-17 6 -19 13 -3 7 -6 4 -6 -6 -1 -17 -8 -18 -91 -11 -71 5 -90 4 -90 -6 0 -8
-3 -11 -6 -8 -3 4 2 18 11 32 9 14 15 31 13 37 -5 15 -44 -50 -56 -93 -16 -61
-14 -166 4 -226 14 -42 31 -69 74 -111 95 -96 178 -112 561 -111 285 1 292 0
310 -61 9 -29 8 -42 -5 -67 -9 -17 -22 -34 -28 -39 -7 -4 -191 -10 -408 -13
l-395 -5 -53 -75 c-29 -41 -59 -83 -67 -92 -7 -9 -21 -28 -30 -42 l-17 -26
499 0 c409 0 509 3 556 15 100 26 174 86 216 174 22 48 26 69 25 146 0 68 -5
101 -21 135 -29 65 -93 124 -171 157 l-67 28 -325 5 c-235 4 -331 8 -347 18
-49 28 -47 132 4 172 25 19 38 20 388 20 l363 0 37 56 c47 70 40 82 -10 14z
m-1078 -102 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M8110 3711 c0 -5 7 -15 17 -22 15 -13 15 -12 4 9 -12 23 -21 28 -21
13z"/>
<path d="M7636 3665 c-9 -13 -16 -27 -16 -30 0 -3 -8 -18 -19 -33 -27 -40
-291 -491 -291 -498 0 -2 -19 -37 -43 -77 -24 -39 -61 -103 -82 -142 -21 -38
-45 -80 -53 -92 l-14 -23 169 0 170 0 14 28 c8 15 42 78 76 140 35 62 63 115
63 117 0 2 13 26 29 53 35 60 71 126 141 257 91 170 105 194 115 195 6 1 35
-48 67 -107 31 -59 95 -179 142 -266 47 -87 86 -163 86 -168 0 -5 -87 -10
-192 -11 l-193 -3 -67 -109 c-38 -60 -68 -113 -68 -118 0 -4 223 -8 495 -8
272 0 495 2 495 5 0 5 -7 18 -138 250 -52 94 -115 203 -139 243 -23 40 -43 75
-43 77 0 2 -26 46 -58 97 -32 51 -71 117 -87 145 -26 50 -75 96 -75 73 0 -6 8
-14 18 -17 20 -7 32 -22 32 -40 0 -15 -24 -7 -62 19 -16 11 -28 15 -28 9 0 -6
5 -11 10 -11 6 0 10 -4 10 -10 0 -5 -22 -10 -50 -10 -27 0 -50 -3 -50 -7 0 -5
-17 -7 -37 -7 -21 1 -41 -4 -45 -10 -5 -7 -8 -3 -8 9 0 15 -2 17 -9 6 -5 -7
-14 -10 -20 -7 -6 4 -15 -3 -20 -16 -10 -23 -10 -22 -10 5 l-1 27 -85 0 c-61
0 -85 3 -85 13 0 8 -4 7 -10 -3 -8 -12 -11 -13 -19 -1 -7 11 -9 11 -13 0 -3
-8 -9 -11 -13 -7 -4 4 -4 13 2 20 11 16 34 68 29 68 -2 0 -11 -11 -20 -25z"/>
<path d="M6362 3673 c92 -2 245 -2 340 0 95 1 20 3 -167 3 -187 0 -265 -2
-173 -3z"/>
<path d="M8750 3655 c-10 -12 -10 -15 2 -15 8 0 15 7 15 15 0 8 -1 15 -2 15
-2 0 -8 -7 -15 -15z"/>
<path d="M9028 3653 c106 -2 277 -2 380 0 103 1 16 2 -193 2 -209 0 -293 -1
-187 -2z"/>
<path d="M9645 3631 c17 -10 32 -17 34 -15 7 7 -33 33 -49 34 -8 0 -1 -8 15
-19z"/>
<path d="M9964 3637 c3 -10 6 -23 6 -28 0 -5 5 -9 10 -9 14 0 12 13 -6 36 -14
17 -15 17 -10 1z"/>
<path d="M9941 3614 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9704 3573 c20 -40 14 -127 -12 -162 -37 -51 -36 -51 -513 -51 l-446
0 -6 -122 c-4 -66 -7 -199 -7 -295 l0 -173 155 0 156 0 -1 163 c0 89 -1 168 0
175 0 9 44 12 183 12 l184 0 129 -152 c71 -84 138 -162 149 -175 20 -23 22
-24 194 -21 l175 3 -94 110 c-52 61 -100 116 -107 123 -6 7 -29 34 -50 60 -21
26 -41 49 -45 50 -18 8 -4 21 55 50 128 64 197 178 197 328 0 52 -4 84 -11 84
-5 0 -7 -4 -4 -10 4 -6 -8 -10 -29 -10 -25 0 -36 4 -36 15 0 11 -11 15 -40 15
-29 0 -40 -4 -40 -15 0 -11 -11 -15 -39 -15 -22 0 -42 -5 -44 -12 -3 -8 -6 -5
-6 6 -1 15 -4 16 -15 7 -12 -10 -15 -8 -18 10 -2 12 -9 24 -16 27 -11 3 -10
-2 2 -25z"/>
<path d="M3519 3318 c-29 -46 -59 -93 -67 -106 l-15 -23 266 1 c234 2 267 4
279 18 12 14 83 127 112 180 6 9 -49 12 -257 12 l-265 0 -53 -82z"/>
<path d="M4871 3235 c-35 -8 -65 -16 -66 -17 -7 -9 -55 -88 -55 -91 0 -2 28
10 63 26 53 26 74 31 142 31 82 1 160 -20 198 -52 28 -25 28 -9 -2 39 -22 34
-38 48 -67 56 -68 20 -146 23 -213 8z"/>
<path d="M4825 3079 c-33 -17 -71 -42 -85 -55 l-24 -24 20 -21 21 -21 45 34
c104 79 249 75 340 -9 l26 -25 23 21 c22 20 22 21 4 41 -11 12 -51 37 -91 56
-61 29 -81 34 -145 34 -63 0 -83 -5 -134 -31z"/>
<path d="M4875 2961 c-58 -26 -70 -43 -45 -66 18 -16 20 -16 53 4 45 28 108
27 158 -1 36 -20 41 -21 56 -6 22 23 11 42 -39 67 -55 26 -129 27 -183 2z"/>
<path d="M4927 2842 c-23 -25 -21 -48 5 -66 32 -23 55 -20 74 9 15 23 15 27 0
50 -20 30 -56 33 -79 7z"/>
<path d="M6300 2444 c-99 -19 -140 -59 -140 -134 0 -41 4 -52 30 -73 35 -30
38 -31 155 -52 95 -18 115 -27 115 -55 0 -33 -29 -45 -104 -44 -54 0 -82 6
-115 23 l-45 23 -23 -28 c-13 -16 -23 -32 -23 -36 0 -4 19 -18 43 -30 33 -17
64 -23 143 -26 128 -5 185 15 210 75 17 40 14 94 -8 121 -20 24 -87 50 -148
57 -90 11 -127 23 -133 44 -14 57 84 79 183 42 l50 -19 20 28 c11 15 20 33 20
38 0 25 -165 58 -230 46z"/>
<path d="M2900 2226 l0 -216 118 0 c187 0 258 28 302 120 31 62 25 161 -12
217 -45 69 -97 87 -265 91 l-143 4 0 -216z m265 124 c53 -20 75 -59 75 -132 0
-46 -4 -58 -27 -80 -44 -40 -67 -48 -142 -48 l-71 0 0 135 0 135 69 0 c38 0
82 -5 96 -10z"/>
<path d="M3716 2247 c-123 -255 -119 -237 -57 -237 49 0 52 1 68 38 l18 37
116 3 117 3 16 -41 c16 -39 17 -40 66 -40 27 0 50 3 50 8 0 4 -43 100 -96 215
l-97 207 -54 0 -54 0 -93 -193z m188 3 c20 -43 36 -82 36 -85 0 -3 -34 -5 -75
-5 -44 0 -75 4 -75 10 0 18 62 160 70 160 4 0 24 -36 44 -80z"/>
<path d="M4310 2400 l0 -40 75 0 75 0 2 -172 3 -173 48 -3 47 -3 0 175 0 175
77 3 77 3 1 35 0 35 -203 3 -202 2 0 -40z"/>
<path d="M5103 2372 c-128 -269 -163 -344 -163 -352 0 -6 22 -10 48 -10 47 0
50 1 67 40 l18 40 113 0 114 0 20 -40 c20 -39 22 -40 71 -40 45 0 50 2 44 18
-3 9 -48 106 -98 214 l-92 197 -55 1 -55 0 -32 -68z m125 -115 c18 -40 32 -78
32 -84 0 -9 -22 -13 -75 -13 -41 0 -75 2 -75 4 0 2 13 32 28 67 16 35 32 72
35 82 11 29 21 19 55 -56z"/>
<path d="M6880 2308 c0 -148 9 -193 47 -238 37 -45 86 -62 173 -63 84 0 111 9
158 48 52 43 66 107 57 258 l-7 127 -44 0 -44 0 0 -123 c0 -137 -8 -179 -42
-207 -53 -44 -145 -32 -178 23 -17 28 -20 51 -20 170 l0 137 -50 0 -50 0 0
-132z"/>
<path d="M7660 2225 l0 -215 148 0 c169 1 215 9 250 44 20 20 26 35 26 77 1
46 -2 54 -31 78 l-31 26 24 28 c46 54 23 133 -46 161 -31 12 -75 16 -190 16
l-150 0 0 -215z m298 123 c17 -17 15 -65 -4 -72 -9 -3 -56 -6 -105 -6 l-89 0
0 45 0 45 93 0 c59 0 97 -4 105 -12z m16 -174 c9 -8 16 -24 16 -34 0 -40 -26
-50 -131 -50 l-99 0 0 50 0 50 99 0 c77 0 103 -4 115 -16z"/>
<path d="M1220 2331 c-14 -4 76 -11 200 -14 124 -4 389 -14 590 -23 201 -8
408 -14 460 -12 94 3 95 3 95 28 l0 25 -660 1 c-363 1 -671 -2 -685 -5z"/>
<path d="M8410 2309 l0 -32 273 7 c149 4 364 11 477 16 113 5 320 12 460 17
380 12 224 18 -532 21 l-678 3 0 -32z"/>
<path d="M1905 2183 c-99 -2 -184 -8 -189 -13 -7 -7 21 -10 79 -10 50 0 169
-4 265 -10 96 -5 248 -12 338 -15 l162 -7 0 31 0 31 -237 -2 c-131 -1 -319 -4
-418 -5z"/>
<path d="M8410 2160 l0 -33 158 6 c86 4 300 12 475 19 316 12 427 28 195 28
-68 0 -282 3 -475 7 l-353 6 0 -33z"/>
<path d="M2949 1730 c-17 -10 -445 -29 -699 -31 -220 -2 -108 -13 290 -29 173
-7 318 -16 322 -19 5 -4 1 -25 -8 -48 l-16 -41 -122 -6 c-66 -3 -301 -11 -521
-17 -220 -6 -401 -12 -403 -14 -1 -1 107 -5 240 -9 338 -9 751 -26 765 -31 14
-5 -1 -61 -21 -82 -7 -7 -125 -15 -356 -24 -190 -7 -338 -14 -330 -16 8 -2
173 -9 366 -17 193 -9 363 -20 378 -26 37 -14 5214 -14 5251 0 15 6 113 14
218 20 358 17 472 24 447 27 -14 1 -146 7 -295 13 -148 6 -271 12 -272 14 -3
3 22 84 28 91 6 5 139 13 512 31 76 3 137 8 135 9 -2 2 -71 6 -153 10 -351 16
-455 22 -461 28 -3 3 0 25 8 49 12 35 20 44 41 46 25 3 40 32 16 32 -5 0 -7
-6 -3 -12 5 -9 2 -9 -9 1 -25 20 -21 24 18 17 22 -4 35 -3 35 4 0 5 -20 10
-44 10 -24 0 -60 7 -79 15 -32 13 -349 15 -2649 15 -1579 0 -2619 -4 -2629
-10z m326 -125 c0 -17 -8 -20 -48 -23 -39 -3 -48 -6 -45 -20 2 -12 15 -18 46
-20 34 -3 43 -7 40 -20 -2 -12 -15 -18 -46 -20 -41 -3 -42 -4 -42 -38 0 -30
-3 -34 -25 -34 -25 0 -25 0 -25 93 0 52 3 97 7 101 4 4 37 6 73 4 57 -3 65 -5
65 -23z m161 -12 c9 -21 27 -66 40 -100 l24 -63 -24 0 c-16 0 -27 7 -31 20 -5
15 -15 20 -45 20 -29 0 -42 -5 -50 -20 -9 -16 -50 -30 -50 -16 0 5 70 178 76
188 13 21 45 6 60 -29z m245 16 c15 -26 -2 -39 -42 -33 -48 8 -53 -9 -7 -25
97 -34 87 -121 -13 -121 -50 0 -69 8 -69 31 0 18 5 19 50 13 65 -9 66 8 3 38
-41 19 -48 28 -51 55 -4 42 28 66 82 59 21 -2 42 -10 47 -17z m224 -4 c0 -14
-8 -21 -26 -23 -22 -3 -28 -9 -33 -40 -3 -20 -6 -54 -6 -74 0 -31 -4 -38 -20
-38 -18 0 -20 7 -20 75 l0 75 -30 0 c-22 0 -30 5 -30 18 0 30 10 33 90 30 67
-3 75 -5 75 -23z m555 0 c24 -22 26 -67 4 -90 -14 -14 -15 -20 -3 -43 7 -15
15 -30 17 -34 2 -5 -8 -8 -22 -8 -17 0 -30 9 -43 30 -18 31 -47 37 -49 10 -2
-35 -5 -40 -24 -40 -19 0 -20 7 -20 101 l0 101 60 -4 c39 -3 66 -11 80 -23z
m225 0 c0 -17 -8 -20 -47 -23 -63 -4 -67 -29 -6 -34 31 -2 44 -8 46 -20 3 -15
-4 -18 -42 -18 -39 0 -46 -3 -46 -19 0 -17 8 -20 47 -23 36 -2 49 -7 51 -20 3
-16 -6 -18 -72 -18 l-76 0 0 93 c0 52 3 97 7 101 4 3 36 5 72 4 58 -3 66 -5
66 -23z m99 19 c13 -5 16 -22 16 -79 l0 -74 42 -3 c31 -2 44 -8 46 -20 3 -16
-5 -18 -67 -18 l-71 0 0 93 c0 105 3 113 34 101z m204 -97 c3 -91 1 -97 -17
-97 -18 0 -20 8 -23 90 -4 105 -3 109 20 106 14 -2 17 -18 20 -99z m203 56
c12 -27 29 -67 40 -90 25 -55 24 -63 -6 -63 -15 0 -25 6 -25 14 0 31 -74 36
-92 6 -17 -26 -63 -28 -53 -2 4 9 18 46 32 81 34 90 41 101 64 101 15 0 26
-13 40 -47z m239 34 c21 -11 25 -20 25 -54 0 -23 3 -45 8 -49 12 -13 8 -47
-10 -66 -12 -14 -31 -18 -82 -18 l-66 0 -3 91 c-1 50 0 95 3 100 9 13 96 11
125 -4z m140 -67 l0 -79 47 -3 c36 -2 49 -7 51 -20 3 -16 -5 -18 -67 -18 l-71
0 0 98 c0 91 1 98 20 99 18 2 20 -4 20 -77z m295 55 c0 -17 -8 -20 -52 -23
-38 -2 -53 -7 -53 -18 0 -10 12 -14 45 -14 38 0 45 -3 45 -19 0 -16 -8 -20
-42 -23 -31 -2 -44 -8 -46 -20 -3 -15 4 -18 47 -18 44 0 51 -3 51 -20 0 -18
-7 -20 -70 -20 l-70 0 0 93 c0 52 3 97 7 101 4 4 37 6 73 4 57 -3 65 -5 65
-23z m453 -53 c3 -67 4 -72 28 -78 37 -9 48 8 54 84 4 51 9 67 20 67 12 0 16
-16 18 -75 2 -65 0 -79 -18 -98 -21 -22 -61 -28 -107 -16 -28 8 -43 51 -43
124 0 62 3 69 28 66 14 -2 18 -16 20 -74z m228 70 c5 -4 27 -29 47 -56 l37
-49 0 50 c0 37 4 53 16 57 29 11 34 -4 34 -100 0 -86 -2 -94 -19 -94 -18 0
-91 74 -91 92 0 4 -4 8 -10 8 -5 0 -10 -22 -10 -50 0 -42 -3 -50 -19 -50 -17
0 -20 11 -26 89 -4 49 -4 94 0 100 7 13 25 14 41 3z m248 -72 l1 -75 43 -3
c34 -3 42 -7 42 -23 0 -17 -7 -19 -68 -19 l-67 0 -3 90 c-4 98 0 113 30 108
19 -3 21 -11 22 -78z m184 -23 c3 -98 3 -98 -20 -95 -22 3 -23 8 -26 87 -3 96
1 114 25 109 16 -3 18 -17 21 -101z m142 64 c11 -22 23 -42 28 -45 5 -3 18 15
30 40 18 36 27 45 45 42 21 -3 22 -8 25 -100 l3 -98 -26 0 c-24 0 -25 3 -25
53 l0 52 -21 -32 c-26 -41 -35 -41 -57 -3 -24 42 -32 37 -32 -20 0 -43 -3 -50
-20 -50 -19 0 -20 7 -20 93 0 52 3 97 7 100 17 18 44 4 63 -32z m238 -64 c3
-95 2 -97 -20 -97 -22 0 -23 3 -22 93 2 115 1 109 22 105 14 -3 17 -17 20
-101z m217 93 c10 -17 -8 -40 -31 -40 -23 0 -24 -3 -24 -75 0 -73 -1 -75 -25
-75 -24 0 -25 2 -25 75 0 73 -1 75 -24 75 -28 0 -40 14 -32 36 4 11 22 14 81
13 42 -1 78 -5 80 -9z m195 -15 c0 -23 -3 -25 -50 -25 -38 0 -50 -4 -50 -15 0
-11 12 -15 45 -15 38 0 45 -3 45 -19 0 -16 -8 -20 -42 -23 -31 -2 -44 -8 -46
-20 -3 -14 6 -17 45 -20 36 -2 49 -7 51 -20 3 -16 -6 -18 -72 -18 l-76 0 0 93
c0 52 3 97 7 100 3 4 37 7 75 7 66 0 68 -1 68 -25z m197 -2 c34 -25 45 -65 30
-111 -15 -45 -46 -62 -114 -62 l-53 0 0 101 0 101 55 -4 c34 -3 66 -13 82 -25z
m-3832 -57 c30 -45 -16 -91 -61 -61 -28 18 -31 46 -8 69 22 23 51 20 69 -8z
m1956 14 c25 -14 24 -52 -1 -75 -30 -27 -70 -7 -70 34 0 42 33 61 71 41z"/>
<path d="M3390 1551 c0 -5 -3 -16 -6 -25 -4 -11 0 -16 14 -16 15 0 19 5 15 20
-6 22 -23 38 -23 21z"/>
<path d="M4370 1555 c0 -23 4 -26 28 -23 19 2 27 9 27 23 0 14 -8 21 -27 23
-24 3 -28 0 -28 -23z"/>
<path d="M5136 1534 c-9 -23 -8 -24 14 -24 11 0 20 2 20 4 0 12 -13 36 -20 36
-4 0 -11 -7 -14 -16z"/>
<path d="M5350 1565 c0 -10 10 -15 30 -15 20 0 30 5 30 15 0 10 -10 15 -30 15
-20 0 -30 -5 -30 -15z"/>
<path d="M5357 1504 c-19 -19 -6 -35 26 -32 39 4 45 32 7 36 -14 2 -29 0 -33
-4z"/>
<path d="M7878 1573 c-2 -5 -4 -28 -4 -53 1 -43 2 -45 31 -45 21 0 33 7 44 26
13 24 13 29 -2 53 -17 25 -61 37 -69 19z"/>
<path d="M8413 1693 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M8408 1673 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
</g>
</svg>







    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
